var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllticketNot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.53 15.6144H5.31729C3.15348 15.6144 1.71094 14.5353 1.71094 12.0174V6.9816C1.71094 4.46371 3.15348 3.38461 5.31729 3.38461H12.53C14.6938 3.38461 16.1363 4.46371 16.1363 6.9816V12.0174C16.1363 14.5353 14.6938 15.6144 12.53 15.6144Z",
    stroke: "#84818A",
    strokeWidth: 1.29492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5291 7.34131L10.2715 9.1398C9.52862 9.72971 8.30967 9.72971 7.56677 9.1398L5.31641 7.34131",
    stroke: "#84818A",
    strokeWidth: 1.29492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllticketNot);
export default __webpack_public_path__ + "static/media/allticketNot.bc38851c5b2b1a0c5b88ba29d01094e7.svg";
export { ForwardRef as ReactComponent };